import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Skeleton } from "@mui/material";
import { useOpsContext } from "../../../ContextsAndProvider/OpsContext";
import { getDocumentDashboard } from "../../api/FillableDocument.js";
import { ViewDateTime } from "../../../utils/DateSupport";
import { decryptData } from "../../EncryptDecrypt";
import "./OpsDashboard.css";

const OpsDocumentsTab = () => {
  const { selectedOrganization, selectedPractitioner } = useOpsContext();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("assigned");

  useEffect(() => {
    if (!selectedOrganization || !selectedPractitioner?.value) {
      setList([]);
      return;
    }
    setLoading(true);
    getDocumentDashboard({
      status: statusFilter,
      practitionerId: selectedPractitioner.value,
      orgId: selectedOrganization,
    })
      .then((res) => setList(res?.data || []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [selectedOrganization, selectedPractitioner?.value, statusFilter]);

  if (!selectedOrganization || !selectedPractitioner) return null;

  return (
    <div className="ops-dashboard-content">
      <div className="ops-doc-filters" style={{ marginBottom: 12 }}>
        {["assigned", "acknowledged", "completed", "cancelled"].map((s) => (
          <button
            key={s}
            type="button"
            className="ops-btn-status"
            style={{
              marginRight: 8,
              padding: "6px 12px",
              border: statusFilter === s ? "1px solid #005da8" : "1px solid #ccc",
              background: statusFilter === s ? "#e9f5ff" : "#fff",
              borderRadius: 4,
              cursor: "pointer",
            }}
            onClick={() => setStatusFilter(s)}
          >
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>
      <div className="table-wrap ops-encounter-table-wrap">
        <Table responsive>
          <thead>
            <tr>
              <th>Category</th>
              <th>Subject / Patient</th>
              <th>Authenticator</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              [1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td colSpan={4}><Skeleton animation="wave" /></td>
                </tr>
              ))
            ) : list.length > 0 ? (
              list.map((doc) => (
                <tr key={doc.id}>
                  <td>{decryptData(doc?.category?.[0]?.coding?.[0]?.display) || "-"}</td>
                  <td>{decryptData(doc?.subject?.display) || "-"}</td>
                  <td>{decryptData(doc?.authenticator?.[0]?.display) || "-"}</td>
                  <td>{doc?.createdAt ? ViewDateTime(doc.createdAt) : "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} style={{ textAlign: "center" }}>No documents</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default OpsDocumentsTab;
